import {useTranslation} from "@i18n";
import MakeModelYearTag from "./MakeModelYearTag/MakeModelYearTag";
import stl from "./MakeModelYearTags.module.css";
import {useLocation, useParams} from "react-router-dom";
import SearchArrowSVG from "./MakeModelYearTag/SVGIcons/SearchArrowSVG";
import {useEffect, useRef, useState} from "react";
import {useLang} from "@/common/Contexts/LanguageContext";
import {FACETS_YEARS_COUNT, LAST_FACET_YEAR} from "@globalConfig";
import useHelpers from "@hooks/useHelpers";

const START_YEAR = LAST_FACET_YEAR - FACETS_YEARS_COUNT;
const END_YEAR = LAST_FACET_YEAR;

const MakeModelYearTags = ({
                               className,
                               selectedOptions,
                               metaData,
                               showYearsTags,
                           }) => {
    const {t} = useTranslation();
    const lang = useLang();
    const {createUrl} = useHelpers();

    const location = useLocation();
    const {year} = useParams();
    const scrollRef = useRef(null);
    const parentRef = useRef(null);
    const anchor1 = useRef(null);
    const anchor2 = useRef(null);
    const scrollAmount = 600;
    const [Iscroll, setIscroll] = useState(false);
    const [IsLast, setIsLast] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (scrollRef.current) {
                setTimeout(() => {
                    checkWrapperShift();
                }, 310);
            }
        };

        if (scrollRef.current) {
            scrollRef.current.addEventListener("scroll", handleScroll);
        }

        return () => {
            if (scrollRef.current) {
                scrollRef.current.removeEventListener("scroll", handleScroll);
            }
        };
    }, []); // Empty dependency array ensures this effect runs only once after initial render

    const scroll = (dir, shift) => {
        if (dir === "left" && scrollRef.current) {
            scrollRef.current.scrollLeft -= shift;
        } else if (dir === "right" && scrollRef.current) {
            scrollRef.current.scrollLeft += shift;
        }
    };

    const checkWrapperShift = () => {
        if (lang === "ar") {
            if (
                anchor1.current?.getBoundingClientRect()?.left >
                parentRef.current?.getBoundingClientRect()?.right
            ) {
                setIscroll(true);
            } else {
                setIscroll(false);
            }

            if (
                anchor2.current?.getBoundingClientRect()?.left >
                parentRef.current?.getBoundingClientRect()?.left
            ) {
                setIsLast(true);
            } else {
                setIsLast(false);
            }
        } else {
            if (
                anchor1.current?.getBoundingClientRect()?.right <
                parentRef.current?.getBoundingClientRect()?.left
            ) {
                setIscroll(true);
            } else {
                setIscroll(false);
            }

            if (
                anchor2.current?.getBoundingClientRect()?.right <
                parentRef.current?.getBoundingClientRect()?.right
            ) {
                setIsLast(true);
            } else {
                setIsLast(false);
            }
        }
    };

    const createData = () => {
        const make = selectedOptions.find((tag) => tag.filterField === "make_id");
        const model = selectedOptions.find((tag) => tag.filterField === "model_id");

        if (model) {
            return {
                tags: Array.from(
                    {length: END_YEAR - START_YEAR + 1},
                    (_, index) => END_YEAR - index
                ),
                title: t("اختر السنة", {ns: "web_search"}),
            };
        }

        if (make) {
            const makeModels = metaData?.seoData?.models;

            return {
                tags: makeModels,
                title: t("اختر الموديل", {ns: "web_search"}),
            };
        }

        const makes = metaData?.seoData?.makes;

        return {tags: makes, title: t("اختر الماركة", {ns: "web_search"})};
    };

    const data = createData();

    const createLink = (tag) => {
        const make = selectedOptions.find((tag) => tag.filterField === "make_id");
        if (!make)
            return createUrl(
                `/autos/${tag?.name_en?.slugify() || tag}`
            );

        return createUrl(
            `${location.pathname.replace(/^(\/en)/, "").slugify()}/${tag?.name_en?.slugify() || tag}`
        );
    };

    if (year) return null;

    if (!data?.tags) return null;

    return (
        <div className={`${stl.wrapper} ${className || ""}`}>
            <strong className={`${stl.title} ${showYearsTags ? "" : "m-hide"} `}>
                {data.title}
            </strong>
            <div
                ref={parentRef}
                className={[
                    stl.parentWrapper,
                    Iscroll ? stl.shiftStyle : undefined,
                    IsLast ? stl.lastScroll : undefined,
                ].join(" ")}>
                {data?.tags.length > 18 && (
                    <SearchArrowSVG
                        className={stl.leftArr}
                        onClick={() => {
                            scroll("left", scrollAmount);
                        }}
                    />
                )}
                <div className={stl.tagsWrapper} ref={scrollRef}>
                    <span className={stl.anchor} ref={anchor1}></span>
                    {data?.tags?.map((tag, i) => {
                        return (
                            <MakeModelYearTag
                                key={i}
                                title={tag.name || tag}
                                url={createLink(tag)}
                            />
                        );
                    })}
                    <span className={stl.anchor} ref={anchor2}></span>
                </div>
                {data?.tags.length > 18 && (
                    <SearchArrowSVG
                        className={stl.rightArr}
                        onClick={() => {
                            scroll("right", scrollAmount);
                        }}
                    />
                )}
            </div>
        </div>
    );
};

export default MakeModelYearTags;
